<template>
  <div
    class="tip-page-box"
    :class="
      type == 'gley'
        ? 'gley-box'
        : type == 'yellow'
        ? 'yellow-box'
        : type == 'gley-empty'
        ? 'gley-empty-box'
        : ''
    "
  >
    <div
      class="left-icon-box"
      :style="
        type == 'gley-empty' ? 'margin-right:2px' : ''
      "
    >
    <span v-if="tipTitle" style="margin-top: -2px">{{ tipTitle }}</span>
      <template v-else>
        <img
          src="@/assets/new-image/tip/gley.svg"
          v-if="type == 'gley' || type == 'gley-empty'"
        />
        <img src="@/assets/new-image/tip/yellow.svg" v-else-if="type == 'yellow'" />
        <img src="@/assets/new-image/tip/primary.png" v-else />
      </template>
    </div>
    <div class="right-tip-box">
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "blue",
    },
    tipTitle: {
      type: String,
      default: '',
    }
  },
};

</script>

<style scoped lang="scss">
.tip-page-box {
  background: #e6f2ff;
  border: 1px solid #a1cfff;
  border-radius: 4px;
  padding: 6px 12px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .left-icon-box {
    margin-right: 8px;
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2px;
    img {
      width: 14px;
      height: 14px;
    }
  }
  .right-tip-box {
    width: calc(100% - 20px);
    height: fit-content;
    line-height: 17px;
    font-size: 12px;
    color: #666666;
    display: inline-block;
  }
}
.gley-box {
  color: #666;
  background: #f1f1f1;
  border-color: #d1d1d1;
}
.gley-empty-box {
  background: transparent !important;
  border-color: transparent;
  color: #999;
  padding: 0px;
  .right-tip-box {
    color: #999;
  }
}
.yellow-box {
  background: #fff6ea !important;
  border-color: #ffddb0;
  color: #666;
}
</style>
